import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ValidationErrors } from '@angular/forms';
import { ICustomControl } from 'src/shared/models/form.model';
import { IonItem, IonModal, IonDatetime, IonLabel, IonInput } from '@ionic/angular/standalone';
import { ValidationComponent } from '../validation/validation.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { DateHelperService } from 'src/shared/services/helpers/date-helper.service';

@Component({
  selector: 'vl-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  standalone: true,
  imports: [
    IonInput,
    IonLabel,
    IonDatetime,
    IonModal,
    IonItem,
    ValidationComponent,
    TranslatePipe,
    NgIf,
    NgFor,
    NgClass,
    FormsModule,
  ],
  providers: [DatePipe],
})
export class DatePickerComponent implements OnChanges {
  @Input() control: ICustomControl;
  @Input() errors: ValidationErrors;
  @Input() compareWithValue: string;
  @Input() submitted = false;
  @Input() value: string;
  @Input() yearsValue: string;
  @Output() valueEmitter: EventEmitter<string> = new EventEmitter<string>();
  isModalOpen: boolean = false;

  constructor(private datePipe: DatePipe, private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && !this.isModalOpen) {
      this.cd.detectChanges();
    }
  }

  setOpen(isOpen: boolean) {
    this.isModalOpen = isOpen;
  
    if (!this.value || isNaN(new Date(this.value).getTime())) {
      const now = new Date();
      now.setSeconds(0);
      now.setMilliseconds(0);
      this.value = DateHelperService.toIonDateTimeLocalISOString(now);
    }
    this.cd.detectChanges();
  }

  valueChanged(event: string) {
    this.valueEmitter.emit(event);
  }

  getDisplayValue(): string {
    if (!this.value) return '';
    const date = new Date(this.value);
    if (isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(date);
  }

  getMinValue(): string | undefined {
    if (this.control.datepickerFormat !== 'time') {
      if (this.compareWithValue) {
        const min = new Date(this.compareWithValue);
        return isNaN(min.getTime()) ? undefined : DateHelperService.toIonDateTimeLocalISOString(min);
      }
      return this.control.minValue;
    }

    const selectedDate = new Date(this.value || new Date());
    const now = new Date();
    if (selectedDate.toDateString() === now.toDateString() && this.control.minValue) {
      const [h, m] = this.control.minValue.split(':').map(Number);
      if (!isNaN(h) && !isNaN(m)) {
        now.setHours(h, m, 0, 0);
        return DateHelperService.toIonDateTimeLocalISOString(now);
      }
    }
    return undefined;
  }
  
}